import { render } from "./passwordreset.vue?vue&type=template&id=c7efede8&scoped=true"
import script from "./passwordreset.vue?vue&type=script&lang=js"
export * from "./passwordreset.vue?vue&type=script&lang=js"

import "./passwordreset.vue?vue&type=style&index=0&id=c7efede8&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7efede8"]])

export default __exports__